<template>
  <div class="app-container">
    <navigation title="预约结果"></navigation>
    <div class="list" v-if="isShow">
      <van-list>
        <van-cell v-for="item in list" :title="item.title">
          <template #title>
            <div class="cell-title">{{ item.title }}</div>
          </template>
          <template #label>
            <p class="message" v-if="item.author">著者：{{ item.author }}</p>
            <p class="message" v-if="item.callNo">架位号：{{ item.callNo }}</p>
            <p class="message" v-if="item.requestDate">预约日期：{{ item.requestDate }}</p>
            <div class="state">
              请求状态：<span class="state-text state-live" v-if="item.statusSequence">{{ item.statusSequence }}</span>
              <span class="state-text state-no-live" v-else>正在处理中</span>
            </div>
            <p class="message" v-if="item.pickUpLoc">取书地点：{{ item.pickUpLoc }}</p>
          </template>
          <template #right-icon>

            <div class="cancel">
              <!-- printStatus 等于p时候不可取消 -->
              <van-button v-if="item.printStatus!=='P'" class="cancel-btn" @click="cancel(item.docNumber,item.itemSequence,item.sequence)">取消</van-button>
              <van-button disabled v-else class="cancel-btn-no">预约成功</van-button>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
    <div class="no-list"  v-if="isShow===false">
      <img src="@/assets/img/no-collection.png" alt="">
      <p>您还没有预约信息</p>
    </div>
    <version></version>
    <scroll></scroll>
  </div>
</template>

<script>
import Vue from 'vue'
import {Cell, CellGroup, List, Icon, Checkbox, Toast} from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'reserve',
  components: {navigation, version, scroll},
  data () {
    return {
      list: [],
      isShow: true
    }
  },
  created () {
    window.scrollTo(0, 0)
    // 获取借阅历史
    this.getList()
  },
  mounted() {
    // this.$nextTick(function(){
    //   Toast.clear()
    // })
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getList () {
      Toast.loading({
        message: '加载中...'
      })
      request('post', '/nlc-api/api/nlc/borInfoH').then(res => {
        Toast.clear()
        console.log('预约列表', res)
        if (res.code === 200) {
          this.list = res.data
          if (this.list.length === 0) {
            this.isShow = false
          }
        } else {
          this.isShow = false
        }
      }).catch(e => {
        Toast.clear()
      })
    },
    // 取消
    cancel (docNum, itemSeq, seq) {
      Toast.loading({
        message: '加载中...'
      })
      var params = {
        docNum: docNum,
        itemSeq: itemSeq,
        seq: seq
      }
      request('post', '/nlc-api/api/nlc/holdReqCancel', params).then(res => {
        console.log('取消', res)
        Toast.clear()
        if (res.code === 200 && res.data) {
          Toast.success('取消成功')
          this.getList()
        } else if (res.code === 200 && res.data !== false) {
          Toast.fail('取消失败')
        } else if (res.code !== 200) {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ECF5FD;
  padding-top:.92rem;
}
.list{
  width:6.94rem;
  min-height:12.28rem;
  margin:.16rem .28rem;
  border-radius:8px;
  background:#fff;
}
.van-cell{
  line-height: .64rem;
  vertical-align: middle;
  border-radius:8px;
}
.van-cell__title{
  width:100%;
  font-size:.3rem;
  color:#444649;
}
>>>.van-cell__label{
  font-size:.28rem;
}
.message{
  line-height:.28rem;
}
.state{
  font-size:.28rem;
  color:#94979C;
}
.cancel{
  position:absolute;
  bottom:.385rem;
  right:.3rem;
}
.state-return{
  color:#008095;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.cancel-btn{
  width: 1rem;
  height: .48rem;
  border-radius: .6rem;
  /*border: 2px solid #008095;*/
  font-size: .28rem;
  /*color:#007F94;*/
  background:#fff;
  font-family: SourceHanSerifCN-Light
}
.van-button--normal{
  padding:0;
}
.cancel-btn-no{
  width: 1.5rem;
  height: .48rem;
  line-height:.48rem;
  background: none;
  border-radius: 60px;
  border:none;
  font-size: .28rem;
  font-family: SourceHanSerifCN-Light;
}
.state-live{
  color:#39A308;
}
.state-no-live{
  color:#FF832B;
}
.no-list{
  width:6.94rem;
  height:12.28rem;
  background:#fff;
  border-radius:8px;
  margin:.16rem .28rem;
  font-size: .28rem;
  font-family: SourceHanSerifCN-Light;
  color: rgba(51, 51, 51, 0.4);
  text-align:center;
}
.no-list img{
  width:3.27rem;
  height:3.84rem;
  margin-top:3.8rem;
}
.cell-title{
  width:100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/view/reserve/index.vue